import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Mtrki07Component } from './mtrki07Pkg.component';
import { JackBaseComponentModule,MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-mtrki07-bill',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    JackBaseComponentModule,
    Mtrki07Component,
    ],
  templateUrl: './mtrki07BillPkg.component.html',
  styleUrls: [],
})
export class Mtrki07BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' mtrki07'; //###
  override masterPage!:  Mtrki07Component;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}